(function () {
  const container = document.querySelector('.contact[data-zendesk-subdomain]');
  if (!container) return;

  const subdomain = container.dataset.zendeskSubdomain.trim();
  if (!subdomain) return;

  const form = container.querySelector('#ContactForm');
  if (!form) return;

  form.setAttribute('action', 'javascript:void(0);');

  const endpoint = `https://${subdomain}.zendesk.com/api/v2/requests.json`;

  const getField = (selector) => {
    const el = form.querySelector(selector);
    return el ? el.value.trim() : '';
  };

  const showMessage = (type, text) => {
    form.querySelectorAll('.form__message, .form-status-list').forEach((el) => el.remove());
    const wrapper = document.createElement('h2');
    wrapper.className = 'form-status form-status-list form__message';
    wrapper.setAttribute('tabindex', '-1');
    wrapper.textContent = text;
    if (type === 'error') wrapper.setAttribute('role', 'alert');
    form.prepend(wrapper);
    wrapper.focus();
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const name = getField('#ContactForm-name');
    const email = getField('#ContactForm-email');
    const subject = getField('#ContactForm-subject');
    const orderNumber = getField('#ContactForm-order');
    const message = getField('#ContactForm-body');

    if (!name || !email || !subject || !message) {
      showMessage('error', 'Please fill in all required fields.');
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    const bodyParts = [message];
    if (orderNumber) bodyParts.push(`\nOrder number: ${orderNumber}`);

    const payload = {
      request: {
        requester: { name, email },
        subject: `[${subject}] ${name}${orderNumber ? ` — Order ${orderNumber}` : ''}`,
        comment: { body: bodyParts.join('\n') },
      },
    };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`Zendesk responded ${response.status}`);

      form.reset();
      showMessage('success', "Thanks — we've received your message and will be in touch soon.");
    } catch (error) {
      console.error('Zendesk submission failed:', error);
      showMessage(
        'error',
        'Sorry, something went wrong sending your message. Please try again or email us directly.'
      );
    } finally {
      if (button) button.disabled = false;
    }
  });
})();
